export const tileKinds = {
  clay: 'clay',
  stone: 'stone',
}
